// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-rank-form .priority {\n  width: 100%;\n}\n.add-rank-form .color-picker {\n  width: 100%;\n}\n.add-rank-form .color-picker .el-color-picker__trigger {\n  width: 100%;\n}\n.add-rank-form .textarea .el-textarea__inner {\n  height: 100px;\n  resize: none;\n}\n.add-rank-form .textarea .el-input__count {\n  right: 8px;\n  bottom: -16px;\n  background: transparent;\n}", ""]);
// Exports
module.exports = exports;
